import { toThresholdFormState } from 'modules/settings/components/custom-notifications/custom-notification-threshold.mapper';
import { CustomAlarmDefinition } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';
import { CustomAlarmFormState } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';

export const mapCustomAlarmFromDomainToForm = (alarm: CustomAlarmDefinition): CustomAlarmFormState => ({
    name: alarm.name,
    eventDraftIds: (alarm.eventsToTrack || []).map((event) => event.id),
    selectedEventIds: (alarm.eventsToTrack || []).map((event) => event.id),
    windowDays: String(alarm.trackingTypeConfiguration.windowDays),
    notifications: {
        yellow: toThresholdFormState(alarm.yellowNotification),
        red: toThresholdFormState(alarm.redNotification),
        gray: toThresholdFormState(alarm.grayNotification),
    },
    isResettable: alarm.isResettable,
    requiresCommentOnReset: alarm.requiresCommentOnReset,
});
